var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            top: "6vh",
            width: "90%",
            visible: _vm.dialogVisible,
            "show-close": false,
            "before-close": () => (_vm.dialogVisible = false),
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "list-header",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("h3", { staticStyle: { display: "inline" } }, [
                _vm._v("计算公式列表"),
              ]),
              _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  !_vm.readonly
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            dialogLoading: _vm.dialogLoading,
                            size: "mini",
                          },
                          on: { click: _vm.addNewRow },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v(" 新增公式 "),
                        ]
                      )
                    : _vm._e(),
                  !_vm.readonly
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "24px" },
                          attrs: {
                            dialogLoading: _vm.dialogLoading,
                            type: "primary",
                            size: "mini",
                          },
                          on: { click: _vm.save },
                        },
                        [
                          _c("i", { staticClass: "el-icon-check" }),
                          _vm._v(" 保存 "),
                        ]
                      )
                    : _vm._e(),
                  !_vm.readonly
                    ? _c("el-divider", { attrs: { direction: "vertical" } })
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "24px" },
                      attrs: { dialogLoading: _vm.dialogLoading, size: "mini" },
                      on: { click: () => (_vm.dialogVisible = false) },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "calculate-list" },
            [
              _c(
                "el-table",
                {
                  ref: "table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    size: "mini",
                    "row-key": "id",
                    border: "",
                    stripe: "",
                    height: "500px",
                  },
                },
                [
                  !_vm.readonly
                    ? _c(
                        "el-table-column",
                        {
                          attrs: {
                            type: "index",
                            label: "#",
                            width: "60",
                            align: "center",
                            fixed: "left",
                          },
                        },
                        [
                          [
                            _c("i", {
                              staticClass: "el-icon-rank drag-icon",
                              staticStyle: { cursor: "move" },
                            }),
                          ],
                        ],
                        2
                      )
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "序号",
                      width: "50",
                      align: "center",
                      fixed: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "formConfigId",
                      label: "表名*",
                      "min-width": "140",
                      align: "center",
                      fixed: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "input-with-error" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      disabled: _vm.readonly,
                                    },
                                    on: {
                                      change: () =>
                                        _vm.handleFormConfigChange(scope.row),
                                    },
                                    model: {
                                      value: scope.row.formConfigId,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "formConfigId", $$v)
                                      },
                                      expression: "scope.row.formConfigId",
                                    },
                                  },
                                  _vm._l(_vm.configData, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.header,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                scope.row.validationErrors &&
                                scope.row.validationErrors.formConfigId
                                  ? _c(
                                      "div",
                                      { staticClass: "error-message" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.validationErrors
                                                .formConfigId
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fieldName",
                      label: "目标字段*",
                      "min-width": "140",
                      align: "center",
                      fixed: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "input-with-error" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      disabled: _vm.readonly,
                                    },
                                    model: {
                                      value: scope.row.fieldName,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "fieldName", $$v)
                                      },
                                      expression: "scope.row.fieldName",
                                    },
                                  },
                                  _vm._l(
                                    _vm.getFieldList(scope.row),
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label:
                                            item.showName || item.itemShowName,
                                          value:
                                            item.fieldName || item.itemName,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                                scope.row.validationErrors &&
                                scope.row.validationErrors.fieldName
                                  ? _c(
                                      "div",
                                      { staticClass: "error-message" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.validationErrors
                                                .fieldName
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "triggerField",
                      label: "条件字段",
                      "min-width": "180",
                      align: "center",
                      fixed: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "input-with-error" },
                              [
                                !_vm.readonly
                                  ? _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          size: "small",
                                          disabled: !scope.row.formConfigId,
                                          clearable: "",
                                        },
                                        model: {
                                          value: scope.row.triggerField,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "triggerField",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.triggerField",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "无", value: "none" },
                                        }),
                                        _vm._l(
                                          _vm.getConditionFieldOptions(
                                            scope.row
                                          ),
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label:
                                                  item.showName ||
                                                  item.itemShowName,
                                                value: `${scope.row.formConfigId},${item.id}`,
                                              },
                                            })
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.renderTriggerField(scope.row)
                                        )
                                      ),
                                    ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "triggerFieldValue",
                      label: "条件值",
                      "min-width": "340",
                      align: "center",
                      fixed: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "input-with-error" }, [
                              !_vm.readonly
                                ? _c(
                                    "div",
                                    { staticClass: "trigger-value-editor" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "trigger-type",
                                          attrs: {
                                            size: "small",
                                            disabled: _vm.isTriggerAlways(
                                              scope.row.triggerField
                                            ),
                                          },
                                          model: {
                                            value: scope.row.triggerValueType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "triggerValueType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.triggerValueType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "固定值",
                                              value: "static",
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "动态字段",
                                              value: "dynamic",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "trigger-operator",
                                          attrs: {
                                            size: "small",
                                            disabled: _vm.isTriggerAlways(
                                              scope.row.triggerField
                                            ),
                                          },
                                          model: {
                                            value: scope.row.triggerOperator,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "triggerOperator",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.triggerOperator",
                                          },
                                        },
                                        _vm._l(
                                          _vm.triggerOperatorOptions,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      scope.row.triggerValueType !== "dynamic"
                                        ? _c("el-input", {
                                            staticClass: "trigger-value",
                                            attrs: {
                                              size: "small",
                                              placeholder: "请输入条件值",
                                              disabled:
                                                _vm.isValueInputDisabled(
                                                  scope.row
                                                ),
                                            },
                                            model: {
                                              value:
                                                scope.row.triggerFieldValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "triggerFieldValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.triggerFieldValue",
                                            },
                                          })
                                        : _c(
                                            "el-select",
                                            {
                                              staticClass: "trigger-value",
                                              attrs: {
                                                size: "small",
                                                placeholder: "请选择动态字段",
                                                disabled:
                                                  _vm.isValueInputDisabled(
                                                    scope.row
                                                  ) || !scope.row.formConfigId,
                                              },
                                              model: {
                                                value:
                                                  scope.row.triggerFieldDynamic,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "triggerFieldDynamic",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.triggerFieldDynamic",
                                              },
                                            },
                                            _vm._l(
                                              _vm.getConditionFieldOptions(
                                                scope.row
                                              ),
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label:
                                                      item.showName ||
                                                      item.itemShowName,
                                                    value: `${scope.row.formConfigId},${item.id}`,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.renderTriggerValue(scope.row))
                                    ),
                                  ]),
                              scope.row.validationErrors &&
                              scope.row.validationErrors.triggerFieldValue
                                ? _c("div", { staticClass: "error-message" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.validationErrors
                                            .triggerFieldValue
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "decimals",
                      label: "小数位",
                      width: "160",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !_vm.readonly
                              ? _c("el-input-number", {
                                  attrs: { min: 0, max: 10, size: "small" },
                                  model: {
                                    value: scope.row.decimals,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "decimals", $$v)
                                    },
                                    expression: "scope.row.decimals",
                                  },
                                })
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.decimals)),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "exclusionRule",
                      label: "舍入方式",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !_vm.readonly
                              ? _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { size: "small" },
                                    model: {
                                      value: scope.row.exclusionRule,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "exclusionRule",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.exclusionRule",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "四舍五入",
                                        value: "round",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "向上取整",
                                        value: "ceil",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "向下取整",
                                        value: "floor",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.exclusionRules[
                                        scope.row.exclusionRule
                                      ]
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "showTemplate",
                      label: "计算公式",
                      "min-width": "250",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !_vm.readonly
                              ? _c(
                                  "div",
                                  { staticClass: "input-with-error" },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticClass: "formula-input",
                                        attrs: {
                                          size: "small",
                                          placeholder: "请输入计算公式（必填）",
                                          required: true,
                                          disabled: true,
                                          "validate-event": false,
                                        },
                                        model: {
                                          value: scope.row.showTemplate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "showTemplate",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.showTemplate",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-edit el-input__icon",
                                          attrs: { slot: "suffix" },
                                          on: {
                                            click: () =>
                                              _vm.handleEditor(scope.row),
                                          },
                                          slot: "suffix",
                                        }),
                                      ]
                                    ),
                                    scope.row.validationErrors &&
                                    scope.row.validationErrors.showTemplate
                                      ? _c(
                                          "div",
                                          { staticClass: "error-message" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.validationErrors
                                                    .showTemplate
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.showTemplate)),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  !_vm.readonly
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "isEnable",
                          label: "启用",
                          width: "60",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return !_vm.readonly
                                  ? [
                                      _c("el-checkbox", {
                                        attrs: {
                                          size: "small",
                                          "true-label": "1",
                                          "false-label": "0",
                                        },
                                        model: {
                                          value: scope.row.isEnable,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "isEnable", $$v)
                                          },
                                          expression: "scope.row.isEnable",
                                        },
                                      }),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                  !_vm.readonly
                    ? _c("el-table-column", {
                        attrs: { label: "操作", width: "60", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("i", {
                                    staticClass: "el-icon-delete",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteRow(scope.$index)
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2270849279
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "公式编辑器",
            visible: _vm.showEditor,
            top: "2vh",
            width: "90%",
            fullscreen: "",
            footer: null,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showEditor = $event
            },
          },
        },
        [
          _c("calculate-editor", {
            attrs: { "available-variables": _vm.cascaderOption },
            on: {
              close: function ($event) {
                _vm.showEditor = false
              },
              confirm: _vm.handleConfirm,
            },
            model: {
              value: _vm.editorRow.showTemplate,
              callback: function ($$v) {
                _vm.$set(_vm.editorRow, "showTemplate", $$v)
              },
              expression: "editorRow.showTemplate",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }